import * as React from 'react'
import { Provider } from 'react-redux'
import * as ActionCable from '@rails/actioncable'

import store from '../store/storeNewDocEdit'
import NewEditDocContainer from '../components/NewEditDoc/Container'
const CableApp = {
  cable: ActionCable.createConsumer()
}

// Generate sessionId only once on client-side to avoid hydration mismatch
let sessionId: number | null = null;
const tenDigitNumber = 10000000000;
const getSessionId = () => {
  if (sessionId === null) {
    sessionId = Math.floor((Math.random() * tenDigitNumber));
  }
  return sessionId;
};

const NewEditDocApp = (props, _railsContext) => (
  () => (
    <Provider store={store()}>
      <NewEditDocContainer cableApp={CableApp} sessionId={getSessionId()} {...props}/>
    </Provider>
  )
)

export default NewEditDocApp

export function UnwrappedNewEditDocApp(props, _railsContext) {
  return (
    <Provider store={store()}>
      <NewEditDocContainer {...props}/>
    </Provider>
  )
}
